import { loader } from '@components/LoadingApp';
import { CurrentEnv } from '@proccess/constants';
import axios from 'axios';
import Cookies from 'js-cookie';

const initSdk = axios.create({
  baseURL: CurrentEnv.API_BE,
  headers: {
    accept: '*/*',
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
  },
});

// tiền điều kiện
initSdk.interceptors.request.use(
  async (config) => {
    loader.show();
    try {
      // lấy hospitalId từ localStorage
      const hospitalId = localStorage.getItem('hospitalid');
      config.headers.HospitalId = hospitalId;
      config.headers.AppId = CurrentEnv?.APP_ID;
      const jwt = Cookies.get('jwt');
      if (jwt) config.headers.Authorization = `Bearer ${jwt}`;

      return config;
    } catch (error) {
      console.error('error xx :>> ', error);
      return config;
    }
  },
  (error) => {
    console.error('error request :>> ', error);
    return Promise.reject(error);
  }
);

// hậu điều kiện
initSdk.interceptors.response.use(
  (config) => {
    // nếu token 401, token hết hạn, kiểm tra và renew token.
    loader.hide();
    return config;
  },
  (error) => {
    loader.hide();
    if (error.response?.status === 401) {
      Cookies.remove('jwt');
      localStorage.clear();
      const channel = new BroadcastChannel('auth_channel');
      channel.postMessage({ type: 'LOGOUT' });
      channel.close();
    }
    return Promise.reject(error);
  }
);

export default initSdk;
